module.exports = __webpack_public_path__ + "img/premium.02c5b49d.svg";